/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorDeliveryTypename = "PharmacyCounselorDelivery" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorDelivery
 */
export interface PharmacyCounselorDelivery {
  /**
   * required if address_type is specified
   * @type {string}
   * @memberof PharmacyCounselorDelivery
   */
  addressLine1?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorDelivery
   */
  addressLine2?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorDelivery
   */
  addressType?: PharmacyCounselorDeliveryAddressTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorDelivery
   */
  orderId?: string;
  /**
   * required if address_type is specified
   * @type {string}
   * @memberof PharmacyCounselorDelivery
   */
  postalCode?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorDelivery
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorDeliveryAddressTypeEnum {
  Registered = "registered",
  Specified = "specified",
  PickUp = "pick_up",
}

export function PharmacyCounselorDeliveryFromJSON(json: any): PharmacyCounselorDelivery {
  return PharmacyCounselorDeliveryFromJSONTyped(json, false);
}

export function PharmacyCounselorDeliveryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorDelivery {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorDeliveryTypename,

    addressLine1: !exists(json, "address_line1") ? undefined : json["address_line1"],
    addressLine2: !exists(json, "address_line2") ? undefined : json["address_line2"],
    addressType: !exists(json, "address_type") ? undefined : json["address_type"],
    orderId: !exists(json, "order_id") ? undefined : json["order_id"],
    postalCode: !exists(json, "postal_code") ? undefined : json["postal_code"],
  };
}

export function PharmacyCounselorDeliveryToJSON(object?: PharmacyCounselorDelivery | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    address_line1: value.addressLine1,
    address_line2: value.addressLine2,
    address_type: value.addressType,
    order_id: value.orderId,
    postal_code: value.postalCode,
  };
}
